// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactForm_container__cbkF8 {
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  max-width: 1824rem;
  height: fit-content;
  border-radius: 8rem;
  padding: 80rem;
  gap: 42rem;
  margin: 75rem 48rem 0 48rem;
  background-color: #ffffff;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 {
    border-radius: 16rem;
    flex-direction: column;
    margin: 86rem 16rem 0 16rem;
    gap: 24rem;
    padding: 24rem;
    height: fit-content;
  }
}
.ContactForm_container__cbkF8 .ContactForm_leftContainer__VvFZY {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  width: 810rem;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_leftContainer__VvFZY {
    width: 100%;
  }
}
.ContactForm_container__cbkF8 .ContactForm_successTitle__icAh4 {
  display: block;
  margin-top: 64rem;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 60rem;
  line-height: 64rem;
  color: #1d2939;
}
.ContactForm_container__cbkF8 .ContactForm_successText__BJ4L5 {
  display: block;
  margin-top: 64rem;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20rem;
  line-height: 28rem;
  color: #667085;
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt {
  display: flex;
  max-width: 475rem;
  width: 100%;
  position: relative;
  flex-direction: column;
  gap: 48rem;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt {
    gap: 32rem;
    max-width: 100%;
  }
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_title__C04y4 {
  width: 100%;
  gap: 6rem;
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_title__C04y4 .ContactForm_mainTitle__RAX5K {
  font-family: "Vivl Rail", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 72rem;
  line-height: 82rem;
  color: #1d2939;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_title__C04y4 .ContactForm_mainTitle__RAX5K {
    font-family: "Vivl Rail", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 42rem;
    line-height: 48rem;
    color: #1d2939;
  }
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_title__C04y4 .ContactForm_subTitle__bs7dj {
  padding-top: 6rem;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 24rem;
  line-height: 32rem;
  color: #667085;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_title__C04y4 .ContactForm_subTitle__bs7dj {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 20rem;
    line-height: 24rem;
    color: #667085;
  }
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw {
  display: flex;
  flex-direction: column;
  gap: 20rem;
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_textareaField__etXvB {
  width: 100%;
  height: 116rem;
  border-radius: 12rem;
  padding: 16rem 20rem;
  background-color: #ffffff;
  border: 1px #d0d5dd solid;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20rem;
  line-height: 24rem;
  color: #98a2b3;
  resize: none;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_textareaField__etXvB {
    padding: 12rem 16rem;
  }
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_textareaField__etXvB {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16rem;
    line-height: 20rem;
    color: #98a2b3;
  }
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_textareaField__etXvB::placeholder {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20rem;
  line-height: 24rem;
  color: #98a2b3;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_textareaField__etXvB::placeholder {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16rem;
    line-height: 20rem;
    color: #98a2b3;
  }
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_textareaField__etXvB * {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20rem;
  line-height: 24rem;
  color: #98a2b3;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_textareaField__etXvB * {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16rem;
    line-height: 20rem;
    color: #98a2b3;
  }
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_textareaField__etXvB:active {
  border: 1px #344054, solid;
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_textareaField__etXvB:hover {
  border: 1px #98a2b3, solid;
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_textareaFielderror__fa4xd {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16rem;
  line-height: 24rem;
  color: #FDA29B;
  border: 1px #F04438, solid;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_textareaFielderror__fa4xd {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12rem;
    line-height: 24rem;
    color: #FDA29B;
  }
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_textareaFielderror__fa4xd * {
  color: #FDA29B;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_textareaField__etXvB {
    height: 84rem;
  }
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_containerSendData__tbTFx {
  display: flex;
  flex-direction: column;
  margin-top: 16rem;
  gap: 16rem;
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_containerSendData__tbTFx .ContactForm_buttonSendData__7vNEu {
  width: 100%;
  height: fit-content;
  border-radius: 12rem;
  padding: 16rem 18rem;
  background-color: #1d2939;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_containerSendData__tbTFx .ContactForm_buttonSendData__7vNEu {
    padding: 13rem 14rem;
  }
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_containerSendData__tbTFx .ContactForm_buttonSendData__7vNEu:hover {
  background-color: #475467;
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_containerSendData__tbTFx .ContactForm_buttonSendData__7vNEu .ContactForm_textContainer__vdqye {
  padding: 0 8rem;
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_containerSendData__tbTFx .ContactForm_buttonSendData__7vNEu .ContactForm_textContainer__vdqye .ContactForm_text__2HTfm {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 20rem;
  line-height: 28rem;
  color: #ffffff;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_containerSendData__tbTFx .ContactForm_buttonSendData__7vNEu .ContactForm_textContainer__vdqye .ContactForm_text__2HTfm {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16rem;
    line-height: 20rem;
    color: #ffffff;
  }
}
.ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_containerSendData__tbTFx .ContactForm_textSendPolitic__CYlfz {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16rem;
  line-height: 24rem;
  color: #98a2b3;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactForm__90jRt .ContactForm_inputFieldContainer__xZqNw .ContactForm_containerSendData__tbTFx .ContactForm_textSendPolitic__CYlfz {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14rem;
    line-height: 16rem;
    color: #98a2b3;
  }
}
.ContactForm_container__cbkF8 .ContactForm_contactSendSuccess__gIqgW {
  max-width: 475rem;
  flex-direction: column;
  gap: 6rem;
  flex-grow: 1;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactSendSuccess__gIqgW {
    width: 100%;
    margin-top: 0;
  }
}
.ContactForm_container__cbkF8 .ContactForm_contactSendSuccess__gIqgW .ContactForm_title__C04y4 {
  font-family: "Vivl Rail", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 72rem;
  line-height: 82rem;
  color: #1d2939;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactSendSuccess__gIqgW .ContactForm_title__C04y4 {
    font-family: "Vivl Rail", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 42rem;
    line-height: 48rem;
    color: #1d2939;
  }
}
.ContactForm_container__cbkF8 .ContactForm_contactSendSuccess__gIqgW .ContactForm_subTitle__bs7dj {
  padding-top: 6rem;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 24rem;
  line-height: 32rem;
  color: #667085;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_contactSendSuccess__gIqgW .ContactForm_subTitle__bs7dj {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 20rem;
    line-height: 24rem;
    color: #667085;
  }
}
.ContactForm_container__cbkF8 .ContactForm_companyInfo__VR\\+LJ {
  width: 319rem;
  height: fit-content;
  gap: 10rem;
}
.ContactForm_container__cbkF8 .ContactForm_companyInfo__VR\\+LJ .ContactForm_text__2HTfm {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20rem;
  line-height: 28rem;
  color: #667085;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_companyInfo__VR\\+LJ .ContactForm_text__2HTfm {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16rem;
    line-height: 24rem;
    color: #667085;
  }
}
.ContactForm_container__cbkF8 .ContactForm_imgContainer__K89ga {
  flex-grow: 1;
}
@media only screen and (max-width: 700px) {
  .ContactForm_container__cbkF8 .ContactForm_imgContainer__K89ga {
    display: none;
  }
}
.ContactForm_container__cbkF8 .ContactForm_imgContainer__K89ga .ContactForm_building__QK5iL {
  width: 810rem;
  height: 684rem;
  object-fit: cover;
  object-position: center;
}`, "",{"version":3,"sources":["webpack://./src/components/ContactForm/ui/ContactForm.module.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAoBA;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;EAEA,kBAAA;EAEA,mBAAA;EAEA,mBAAA;EACA,cAAA;EACA,UAAA;EAEA,2BAAA;EAEA,yBCCM;ADzBR;AE+HE;EFtHF;IAkBI,oBAAA;IAEA,sBAAA;IAEA,2BAAA;IAEA,UAAA;IACA,cAAA;IACA,mBAAA;EA1BF;AACF;AA6BE;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;AA3BJ;AE+GE;EFxFA;IAMI,WAAA;EAzBJ;AACF;AA2BE;EACE,cAAA;EACA,iBAAA;EE1DF,iCDFU;ECGV,kBAAA;EACA,gBFyDkC;EExDlC,gBAAA;EACA,kBAAA;EACA,cDKS;AD6BX;AAsBE;EACE,cAAA;EACA,iBAAA;EE/DF,iCDFU;ECGV,kBAAA;EACA,gBAH0D;EAI1D,gBAAA;EACA,kBAAA;EACA,cDES;AD0CX;AAiBE;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EAEA,UAAA;AAhBJ;AE8EE;EFrEA;IAUI,UAAA;IACA,eAAA;EAfJ;AACF;AAmBI;EACE,WAAA;EACA,SAAA;AAjBN;AAmBM;EEtFJ,oCDHW;ECIX,kBAAA;EACA,gBFDgC;EEEhC,gBAAA;EACA,kBAAA;EACA,cDKS;ADiEX;AE4DE;EFjDI;IEtFJ,oCDHW;ICIX,kBAAA;IACA,gBFEkC;IEDlC,gBAAA;IACA,kBAAA;IACA,cDKS;ED0ET;AACF;AAKM;EAjFJ,iBAAA;EETA,iCDFU;ECGV,kBAAA;EACA,gBFQgC;EEPhC,gBAAA;EACA,kBAAA;EACA,cDES;ADuFX;AEyCE;EF7CI;IE1FJ,iCDFU;ICGV,kBAAA;IACA,gBFWkC;IEVlC,gBAAA;IACA,kBAAA;IACA,cDES;EDgGT;AACF;AATI;EACE,aAAA;EACA,sBAAA;EAEA,UAAA;AAUN;AARM;EACE,WAAA;EACA,cAAA;EEVN,oBAAA;EACA,oBAAA;EAEA,yBD/DM;ECgEN,yBAAA;EAjGA,iCDFU;ECGV,kBAAA;EACA,gBAoFgC;EAnFhC,gBAAA;EACA,kBAAA;EACA,cDCS;EDmGH,YAAA;AAmBR;AEWE;EFlCI;IEDF,oBAAA;EF4BF;AACF;AEME;EFlCI;IErGJ,iCDFU;ICGV,kBAAA;IACA,gBAsFkC;IArFlC,gBAAA;IACA,kBAAA;IACA,cDCS;EDoIT;AACF;AElCE;EAzGA,iCDFU;ECGV,kBAAA;EACA,gBAoFgC;EAnFhC,gBAAA;EACA,kBAAA;EACA,cDCS;AD6IX;AEZE;EA9BA;IAzGA,iCDFU;ICGV,kBAAA;IACA,gBAsFkC;IArFlC,gBAAA;IACA,kBAAA;IACA,cDCS;EDsJT;AACF;AEhDE;EA7GA,iCDFU;ECGV,kBAAA;EACA,gBAoFgC;EAnFhC,gBAAA;EACA,kBAAA;EACA,cDCS;AD+JX;AE9BE;EA1BA;IA7GA,iCDFU;ICGV,kBAAA;IACA,gBAsFkC;IArFlC,gBAAA;IACA,kBAAA;IACA,cDCS;EDwKT;AACF;AE9DE;EACE,0BAAA;AFgEJ;AE7DE;EACE,0BAAA;AF+DJ;AE5DE;EAzHA,iCDFU;ECGV,kBAAA;EACA,gBAwHmC;EAvHnC,gBAAA;EACA,kBAAA;EACA,cDcU;EC2GR,0BAAA;AFgEJ;AEvDE;EAdA;IAzHA,iCDFU;ICGV,kBAAA;IACA,gBA0HqC;IAzHrC,gBAAA;IACA,kBAAA;IACA,cDcU;EDoLV;AACF;AExEI;EACE,cD9GM;ADwLZ;AEpEE;EFlCI;IAOI,aAAA;EAmGR;AACF;AAhGM;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,UAAA;AAkGR;AAhGQ;EACE,WAAA;EACA,mBAAA;EACA,oBAAA;EAEA,oBAAA;EACA,yBClHC;ADmNX;AEtFE;EFjBM;IASI,oBAAA;EAkGV;AACF;AAhGU;EACE,yBC3HD;AD6NX;AA/FU;EACE,eAAA;AAiGZ;AA/FY;EEzIV,iCDFU;ECGV,kBAAA;EACA,gBFwIyC;EEvIzC,gBAAA;EACA,kBAAA;EACA,cD4BM;AD+MR;AEzGE;EFEU;IEzIV,iCDFU;ICGV,kBAAA;IACA,gBF2I2C;IE1I3C,gBAAA;IACA,kBAAA;IACA,cD4BM;EDwNN;AACF;AAvGQ;EEnJN,iCDFU;ECGV,kBAAA;EACA,gBFkJwC;EEjJxC,gBAAA;EACA,kBAAA;EACA,cDCS;AD4PX;AE3HE;EFYM;IEnJN,iCDFU;ICGV,kBAAA;IACA,gBFqJ0C;IEpJ1C,gBAAA;IACA,kBAAA;IACA,cDCS;EDqQT;AACF;AA7GE;EAEE,iBAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AA8GJ;AE3IE;EFwBA;IAQI,WAAA;IACA,aAAA;EA+GJ;AACF;AA7GI;EE3KF,oCDHW;ECIX,kBAAA;EACA,gBFDgC;EEEhC,gBAAA;EACA,kBAAA;EACA,cDKS;ADsRX;AEzJE;EFoCE;IE3KF,oCDHW;ICIX,kBAAA;IACA,gBFEkC;IEDlC,gBAAA;IACA,kBAAA;IACA,cDKS;ED+RT;AACF;AA5HI;EArKF,iBAAA;EETA,iCDFU;ECGV,kBAAA;EACA,gBFQgC;EEPhC,gBAAA;EACA,kBAAA;EACA,cDES;AD4SX;AE5KE;EFuCE;IE9KF,iCDFU;ICGV,kBAAA;IACA,gBFWkC;IEVlC,gBAAA;IACA,kBAAA;IACA,cDES;EDqTT;AACF;AAzIE;EACE,aAAA;EACA,mBAAA;EAEA,UAAA;AA0IJ;AAxII;EE1LF,iCDFU;ECGV,kBAAA;EACA,gBFyLoC;EExLpC,gBAAA;EACA,kBAAA;EACA,cDES;ADmUX;AEnME;EFmDE;IE1LF,iCDFU;ICGV,kBAAA;IACA,gBF4LsC;IE3LtC,gBAAA;IACA,kBAAA;IACA,cDES;ED4UT;AACF;AAjJE;EACE,YAAA;AAmJJ;AEhNE;EF4DA;IAGI,aAAA;EAqJJ;AACF;AApJI;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;AAsJN","sourcesContent":["@use \"/src/styles/mixins\" as *;\n@use \"/src/styles/variables\" as *;\n\n@mixin title {\n  @include fnt(72, 82, $gray-800, 400, $font-title);\n\n  @include mobile {\n    @include fnt(42, 48, $gray-800, 400, $font-title);\n  }\n}\n\n@mixin subtitle {\n  padding-top: 6rem;\n  @include fnt(24, 32, $gray-500, 400);\n\n  @include mobile {\n    @include fnt(20, 24, $gray-500, 400);\n  }\n}\n\n.container {\n  display: flex;\n  flex-wrap: nowrap;\n  position: relative;\n\n  max-width: 1824rem;\n\n  height: fit-content;\n\n  border-radius: 8rem;\n  padding: 80rem;\n  gap: 42rem;\n\n  margin: 75rem 48rem 0 48rem;\n\n  background-color: $white;\n\n  @include mobile {\n    border-radius: 16rem;\n\n    flex-direction: column;\n\n    margin: 86rem 16rem 0 16rem;\n\n    gap: 24rem;\n    padding: 24rem;\n    height: fit-content;\n\n  }\n\n  .leftContainer {\n    flex-grow: 1;\n    display: flex;\n    justify-content: center;\n    width: 810rem;\n    @include mobile {\n      width: 100%;\n    }\n  }\n  .successTitle {\n    display: block;\n    margin-top: 64rem;\n    @include fnt(60, 64, $gray-800, 600);\n  }\n  .successText {\n    display: block;\n    margin-top: 64rem;\n    @include fnt(20, 28, $gray-500);\n  }\n  .contactForm {\n    display: flex;\n    max-width: 475rem;\n    width: 100%;\n    position: relative;\n    flex-direction: column;\n\n    gap: 48rem;\n\n    @include mobile {\n      gap: 32rem;\n      max-width: 100%;\n    }\n\n\n\n    .title {\n      width: 100%;\n      gap: 6rem;\n\n      .mainTitle {\n        @include title;\n      }\n\n      .subTitle {\n        @include subtitle;\n      }\n    }\n\n    .inputFieldContainer {\n      display: flex;\n      flex-direction: column;\n\n      gap: 20rem;\n\n      .textareaField {\n        width: 100%;\n        height: 116rem;\n        @include inputField;\n        resize: none;\n\n        @include mobile {\n          height: 84rem;\n        }\n      }\n\n      .containerSendData {\n        display: flex;\n        flex-direction: column;\n        margin-top: 16rem;\n        gap: 16rem;\n\n        .buttonSendData {\n          width: 100%;\n          height: fit-content;\n          border-radius: 12rem;\n\n          padding: 16rem 18rem;\n          background-color: $gray-800;\n\n          @include mobile {\n            padding: 13rem 14rem;\n          }\n\n          &:hover {\n            background-color: $gray-600;\n          }\n\n          .textContainer {\n            padding: 0 8rem;\n\n            .text {\n              @include fnt(20, 28, $white, 500, $font-text);\n\n              @include mobile {\n                @include fnt(16, 20, $white, 500, $font-text);\n              }\n            }\n          }\n        }\n\n        .textSendPolitic {\n          @include fnt(16, 24, $gray-400, 400, $font-text);\n\n          @include mobile {\n            @include fnt(14, 16, $gray-400, 400, $font-text);\n          }\n        }\n\n      }\n    }\n  }\n\n  .contactSendSuccess {\n    //width: 603rem;\n    max-width: 475rem;\n    flex-direction: column;\n    gap: 6rem;\n    flex-grow: 1;\n\n    @include mobile {\n      width: 100%;\n      margin-top: 0;\n    }\n\n    .title {\n      @include title;\n    }\n    .subTitle {\n      @include subtitle;\n    }\n\n  }\n\n  .companyInfo {\n    width: 319rem;\n    height: fit-content;\n\n    gap: 10rem;\n\n    .text {\n      @include fnt(20, 28, $gray-500, 400);\n\n      @include mobile {\n        @include fnt(16, 24, $gray-500, 400);\n      }\n    }\n  }\n\n  .imgContainer {\n    flex-grow: 1;\n    @include mobile {\n      display: none;\n    }\n    .building {\n      width: 810rem;\n      height: 684rem;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n}","$font-title: \"Vivl Rail\", sans-serif;\n$font-text: \"Roboto\", sans-serif;\n\n$gray-20: #f9f9fa;\n$gray-25: #fcfcfd;\n$gray-50: #f9fafb;\n$gray-100: #f2f4f7;\n$gray-200: #eaecf0;\n$gray-300: #d0d5dd;\n$gray-400: #98a2b3;\n$gray-500: #667085;\n$gray-600: #475467;\n$gray-700: #344054;\n$gray-800: #1d2939;\n$gray-900: #101828;\n$gray-950: #0C111D;\n\n$main: #47C4F0;\n\n$error-50: #FEF3F2;\n$error-100: #FEE4E2;\n$error-200: #FECDCA;\n$error-300: #FDA29B;\n$error-400: #F97066;\n$error-500: #F04438;\n$error-600: #D92D20;\n\n$green: #17B26A;\n$red: #F04438;\n$orange: #F79009;\n\n$success: $green;\n$error: $red;\n$warning: $orange;\n\n$black: $gray-900;\n$white: #ffffff;\n$text-gray: $gray-500;\n$text-color: #2c2d2e;\n$text-color-secondary: $text-gray;\n$border: $gray-300;\n\n$mobile-width: 700;\n$tablet-width: 1024;\n$laptop-width: 1440;\n$hd: 1680;\n$hd-width: 1920;\n\n$main-container: 1824;\n\n$tr: 0.2s ease-out;","@use \"variables\" as *;\n\n@mixin fnt($size: 16, $height: 24, $color: $black, $weight: 400, $font: $font-text, $unit: \"rem\") {\n  font-family: $font;\n  font-style: normal;\n  font-weight: $weight;\n  font-size: #{$size}#{$unit};\n  line-height: #{$height}#{$unit};\n  color: $color;\n}\n\n@mixin scrollable {\n  display: flex;\n  overflow-x: auto;\n\n  gap: 24rem;\n  margin-top: 32rem;\n  padding: 0 48rem;\n\n  @media(min-width: #{$main-container + 1}px) {\n    padding: 0 calc((100vw - #{$main-container}px) / 2);\n  }\n\n  @include mobile {\n    margin-top: 16rem;\n    gap: 16rem;\n    padding: 0 16rem;\n  }\n}\n\n@mixin container($margin: 124rem auto) {\n  margin: $margin;\n  width: 100%;\n  padding: 0 48px;\n  @media (min-width: #{$main-container + 1}px) {\n    width: #{$main-container + 32}px;\n\n  }\n  @include mobile {\n    padding: 0 16rem;\n  }\n}\n\n@mixin scrollButtonContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: end;\n  height: fit-content;\n  width: fit-content;\n  gap: 16rem;\n\n  @include mobile {\n    display: none;\n  }\n}\n\n@mixin sectionHeader {\n  display: inline;\n  gap: 24rem;\n\n  img {\n    height: 68rem;\n    width: 68rem;\n    margin-right: 12rem;\n    @include mobile {\n      height: 42rem;\n      width: 42rem;\n    }\n  }\n\n  @include fnt(72, 82, $gray-800, 400, $font-title);\n  @include mobile {\n    @include fnt(32, 42, $gray-800, 400, $font-title);\n  }\n}\n\n@mixin header {\n  width: 100%;\n  padding: 0 48rem;\n  height: fit-content;\n  @include sectionHeader;\n  @include mobile {\n    padding: 0 16rem;\n  }\n  @content\n}\n\n@mixin textToMobile {\n  @include fnt(20, 24, $gray-400, 400, $font-text);\n  @include mobile {\n    @include fnt(16, 20, $gray-400, 400, $font-text);\n  }\n}\n\n@mixin inputField {\n  border-radius: 12rem;\n  padding: 16rem 20rem;\n\n  background-color: $white;\n  border: 1px $gray-300 solid;\n\n  @include mobile {\n    padding: 12rem 16rem;\n  }\n\n  @include textToMobile;\n\n  &::placeholder {\n    @include textToMobile;\n  }\n\n  * {\n    @include textToMobile;\n  }\n\n  &:active {\n    border: 1px $gray-700, solid;\n  }\n\n  &:hover {\n    border: 1px $gray-400, solid;\n  }\n\n  &error {\n    @include fnt(16, 24, $error-300, 500, $font-text);\n    @include mobile {\n      @include fnt(12, 24, $error-300, 500, $font-text);\n    }\n    border: 1px $error-500, solid;\n\n    * {\n      color: $error-300;\n    }\n  }\n}\n\n@mixin mobile {\n  @media only screen and (max-width: #{$mobile-width}px) {\n    @content;\n  }\n}\n\n@mixin laptop {\n  @media only screen and (max-width: #{$laptop-width}px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: #{$tablet-width}px) {\n    @content;\n  }\n}\n\n@mixin hd {\n  @media only screen and (max-width: #{$hd-width}px) {\n    @content;\n  }\n}\n\n@mixin hd-plus {\n  @media only screen and (min-width: #{$hd-width}px) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ContactForm_container__cbkF8`,
	"leftContainer": `ContactForm_leftContainer__VvFZY`,
	"successTitle": `ContactForm_successTitle__icAh4`,
	"successText": `ContactForm_successText__BJ4L5`,
	"contactForm": `ContactForm_contactForm__90jRt`,
	"title": `ContactForm_title__C04y4`,
	"mainTitle": `ContactForm_mainTitle__RAX5K`,
	"subTitle": `ContactForm_subTitle__bs7dj`,
	"inputFieldContainer": `ContactForm_inputFieldContainer__xZqNw`,
	"textareaField": `ContactForm_textareaField__etXvB`,
	"textareaFielderror": `ContactForm_textareaFielderror__fa4xd`,
	"containerSendData": `ContactForm_containerSendData__tbTFx`,
	"buttonSendData": `ContactForm_buttonSendData__7vNEu`,
	"textContainer": `ContactForm_textContainer__vdqye`,
	"text": `ContactForm_text__2HTfm`,
	"textSendPolitic": `ContactForm_textSendPolitic__CYlfz`,
	"contactSendSuccess": `ContactForm_contactSendSuccess__gIqgW`,
	"companyInfo": `ContactForm_companyInfo__VR+LJ`,
	"imgContainer": `ContactForm_imgContainer__K89ga`,
	"building": `ContactForm_building__QK5iL`
};
export default ___CSS_LOADER_EXPORT___;
